define('bizzabo/models/Partner',[
    'backbone',
    'backbone-validation',
    'bizzabo/bzapi',
    'bizzabo/utils',
    'GSModel',
    'bizzabo/models/ValidationObject'
], function(
    Backbone,
    BackboneValidation,
    BZAPI,
    UTILS,
    GSModel,
    ValidationObject
    ) {

    var Partner = GSModel.extend({

        defaults : {
            "offer-status" : true
        },
        validationObject : undefined,

        initialize : function() {
            this.validationObject = new ValidationObject(this);
        },

        setters : {
            'website-url' : function(value) {
                var valueWithHTTP = 'http://' + value;
                return (Backbone.Validation.patterns.url.test(valueWithHTTP)) ? valueWithHTTP : value;
            },
            'facebook-url' : function(value) {
                var valueWithHTTP = 'http://' + value;
                return (Backbone.Validation.patterns.url.test(valueWithHTTP)) ? valueWithHTTP : value;
            },
            'linkedin-url' : function(value) {
                var valueWithHTTP = 'http://' + value;
                return (Backbone.Validation.patterns.url.test(valueWithHTTP)) ? valueWithHTTP : value;
            },
            'custom-button-1-url' : function(value) {
                var valueWithHTTP = 'http://' + value;
                return (Backbone.Validation.patterns.url.test(valueWithHTTP)) ? valueWithHTTP : value;
            },
            'custom-button-2-url' : function(value) {
                var valueWithHTTP = 'http://' + value;
                return (Backbone.Validation.patterns.url.test(valueWithHTTP)) ? valueWithHTTP : value;
            }
        },

        parse : function(response) {
            return this.unfoldLogoSet(this.unfoldMarkersData(response));
        },

        calculateTotalActions : function() {
            var actions = [
                "follow-on-linkedin",
                "follow-on-twitter",
                "like-on-facebook",
                "request-to-contact",
                "view-website",
                "view-custom-link-1",
                "view-custom-link-2",
                "view-twitter-page",
                "view-linkedin-page",
                "view-facebook-page"
            ];
            var analytics = this.get('analytics') || {};
            return _(actions).reduce(function(memo, action){
                return memo + (analytics[action] || 0);
            }, 0);
        },

        validation : {
            'company-name' : [
                {
                    required : true,
                    msg : 'Name is required'
                },
                {
                    maxLength : 150,
                    msg : 'Name is too long'
                }
            ],
            'location-at-event' : {
                required : false,
                maxLength : 20,
                msg : 'Booth is too long'
            },
            'description' : {
                required : false,
                maxLength : 10000,
                msg : 'Description is too long'
            },
            'offer-text' : {
                required : false,
                maxLength : 250,
                msg : 'Offer is too long'
            },
            'phone' : {
                required : false,
                maxLength : 15,
                msg : 'Phone is too long'
            },
            'email' : {
                required : false,
                maxLength : 50,
                pattern : 'email',
                msg : 'Email address is invalid'
            },
            'website-url' : {
                required : false,
                maxLength : 255,
                pattern : 'url',
                msg : 'Website address is invalid'
            },
            'facebook-url' : {
                required : false,
                maxLength : 255,
                pattern : 'url',
                msg : 'Facebook address is invalid'
            },
            'linkedin-url' : {
                required : false,
                maxLength : 255,
                pattern : 'url',
                msg : 'Linkedin address is invalid'
            },
            'custom-button-1-name' : {
                required : false,
                maxLength : 34,
                msg : 'Link name too long'
            },
            'custom-button-1-url' : {
                required : false,
                maxLength : 255,
                pattern : 'url',
                msg : 'Link address is invalid'
            },
            'custom-button-2-name' : {
                required : false,
                maxLength : 34,
                msg : 'Link name too long'
            },
            'custom-button-2-url' : {
                required : false,
                maxLength : 255,
                pattern : 'url',
                msg : 'Link address is invalid'
            },
            'twitter-handle' : [
                {
                    required : false,
                    maxLength : 15,
                    msg : 'Twitter name too long'
                },
                {
                    pattern : 'twitterScreenName',
                    msg : 'Twitter name is invalid'
                }
            ]
        },

        unfoldMarkersData : function(attrs) {
            return UTILS.unfoldAttribute(attrs, 'markers-data');
        },

        unfoldLogoSet : function(attrs) {
            return UTILS.unfoldAttribute(attrs, 'logo-set');
        }

    });

    return Partner;

});
